import React from 'react'
import SarasInput from '../../input/textField/SarasInput'
import SarasAC from '../../input/autocomplete/SarasAutocomplete2'
import SarasDatePicker from '../../input/datePicker/SarasDatePicker'
import * as fn from "../../../helper/uiFunctions";

//sample code for study
//https://www.pluralsight.com/guides/handling-multiple-inputs-with-single-onchange-handler-react

//input from server theb update.

const FormInput = (props) => {
    //this should be default format for reading props for all form controls
    const { formObject, action, rowKey, headerKey, format, alwaysRender, acData, roClass, roStyle, onChange, ...restProps } = props;
    // console.log('data', rowKey, action.paramName, formObject);

    //set server side values for auto complete
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const isRO = formObject.getValueFromKey(viewData, "dataList.isRO", "0");
    const useValF = formObject.getValueFromKey(viewData, "dataList.useValF", props.useValF);
    
    // let acData;
    // if(dataProcessingFun){
    //     acData = dataProcessingFun(viewData);
    // }
    //pass this handle to the input control and ensure it returns the selected value
    //in case of ac value should contain an object {key: val, text: text to display}
    const onInputChange = (e, value) => {
        //console.log("form input changed", e, action, value);
        let customAction = action;
        if(customAction.InputType === 'ac' && fn.compareNumber(useValF, 1))
        {
            value = { key: value.text, text: value.text };
        }

        if(customAction.actionParam){
            let params = formObject.getDependantValue(customAction.actionParam, rowKey, headerKey, customAction.paramName)
            customAction.actionParam = {...params};
        }
        
        //whenever alwaysRender is true it means that the auto complete is not linked with viewdata
        //and it also means that the on selection the selected value will be sent back to api
        if(alwaysRender && customAction.InputType === 'ac'){
            if(customAction.actionParam){
                customAction.actionParam["rowId"] = value.key;
            }
        }

        if (formObject.onFormValueChange) formObject.onFormValueChange(customAction, rowKey, headerKey, value);

        //send the parameters reqired by the form
        if (customAction.actionId) formObject.onFormAction(customAction, rowKey, headerKey);

        if(onChange) onChange(value);
    }

    //this is used for AC, where in formula will be passed and its interpreted value will be returned back
    //this function will be used for acMethod (return value string), acDepCtrl (return value object)
    //starting with # means it is like paramName and its value will come from another column of same row
    //starting with % means it is like the key and its value will come from the same column and within that column for matching key
    const onGetDependantValue = (formula) => {
        let params = formObject.getDependantValue(formula, rowKey, headerKey, action.paramName);

        return params;
    };

    const getValue = () => {
        let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);

        if (format === "#" && fn.compareNumber(value, 0))
            value = '';

        return value;
    }

    //render input or ac or dp control from input library based on action.InputType 
    //- see sample usage in PocViewer.js
    //NOTE: do not render label control
    //NOTE: use formObject.getState(action.paramName) to get the value for this input
    if((viewData || alwaysRender) && hide === "0"){
        let val = viewData? viewData.val : '';
        let valF = viewData? viewData.valF : '';

        if(fn.compareNumber(isRO, 1)) {
            return (<span className={roClass} style={roStyle} >{getValue()}</span>)
        }
        else if (action.InputType === 'input' || 
                action.InputType === 'password' || 
                action.InputType === 'hidden') {
            valF = fn.compareNumber(useValF, 1) ? valF || val : val || valF;
            
            return (
                <SarasInput onChange={onInputChange} 
                type={action.InputType === 'input' ? 'text' : action.InputType} 
                value={valF}  {...restProps} />
            )
        }
        else if (action.InputType === 'ac') {
            valF = fn.compareNumber(useValF, 1) ? valF || val : valF;
            console.log("print tag", restProps.acDepCtrl)

            return (
                <SarasAC onChange={onInputChange} value={val} label={valF} acData={acData} useValF={useValF} {...action}  {...restProps} onGetDependantValue={onGetDependantValue} />
            )
        }
        else if (action.InputType === 'dp') {
            return (
                <SarasDatePicker onChange={onInputChange} value={val}  {...restProps} />
            )
        }
    }

    return (null);
}

export default FormInput;
